"use client";

import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-hot-toast";
import axios from "axios";
import styles from "../../styles/caseManagerAdmin.module.css";
import search from "../../assets/images/search.png";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/spinner";
import { BASE_URL } from "../../utils/constants";
import Tooltip from "../../components/shared-modules/Tooltip";
import AddLocationModal from "./addLocationModal";
import EditStatusModal from "./statuses/editStatusModal";
import DeleteStatus from "./statuses/deleteStatusModal";
import AddStatusModal from "./statuses/addStatusModal";
import { getUserIdentity } from "../../utils/authorization";
import { getAllStatuses } from "../../services/admin/statuses";
import { sanitizeAccountName } from "../../utils/fileNaming";

import {
  ToggleTabs,
  ToggleTabTrigger,
  ToggleTabList,
  TogglePanel,
  ToggleTabPanels
} from "../../components/ui/toggle-tabs";

import EditLocationModal, {
  ActiveLocation,
  DeleteLocation
} from "./editLocationModal";
import {
  ActiveStaffModal,
  AddStaffModal,
  DeleteStaff,
  EditStaffModal
} from "./addStaffModal";

import {
  ActiveExternalStaff,
  AddExternalStaff,
  DeleteExternalStaff,
  EditExternalStaff
} from "../../components/staff/external";
import Table from "../../components/table";
import Button from "../../components/button-v1";
import EditAccountInfoModal from "../../components/organization/udpate";
import { FaPlus, FaVideo } from "react-icons/fa6";
import { handleApiError } from "../../utils/handleApiError";
import { getSummary } from "../../services/case-manager/billings";
import { saveAs } from "file-saver";
import { formatUSADate } from "../../utils/dateFormatters";
import { convertUTCToLocal } from "../../utils/helper";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../../components/ui/dialog";
import { months } from "../../utils/constants";
import {
  Select,
  SelectTrigger,
  SelectItem,
  SelectContent,
  SelectValue
} from "../../components/ui/select";
import { generateYears } from "../../utils/constants";
import { Badge } from "../../components/ui/badge";
import { FaLock } from "react-icons/fa";
import { useQuery } from "@tanstack/react-query";
import { getExternalProviders } from "../../services/admin/providers";
import useRoles from "../../hooks/useRoles";
import { displayDate } from "../../utils/helper";
import { FaPen } from "react-icons/fa";
import OrgDataBoundsModal from "./orgDataBoundsModal";


const CaseManagerAdmin = () => {
  const locationId = JSON.parse(sessionStorage.getItem("current_loc"))?.id;
  const staffId = JSON.parse(localStorage.getItem("user"))?.staff_id;
  const { roles } = useRoles();
  const [nameSearch, setNameSearch] = useState("");
  const [positionSearch, setPositionSearch] = useState("");
  const [tenantInfo, setTenantInfo] = useState({});
  const [locationList, setLocationList] = useState([]);
  const [LocationsLoading, setLocationsLoading] = useState(true);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAddlocationOpen, setIsAddlocationOpen] = useState(false);
  const [isAddStaffOpen, setIsAddStaffOpen] = useState(false);
  const [isAddExternalStaffOpen, setIsAddExternalStaffOpen] = useState(false);
  const [isEditlocationOpen, setIsEditlocationOpen] = useState(false);
  const [isEditStaffOpen, setIsEditStaffOpen] = useState(false);
  const [isEditExternalStaffOpen, setIsEditExternalStaffOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteStaffModalOpen, setIsDeleteStaffModalOpen] = useState(false);
  const [isDeleteExternalStaffModalOpen, setIsDeleteExternalStaffModalOpen] =
    useState(false);
  const [isActiveModalOpen, setIsActiveModalOpen] = useState(false);
  const [isActiveExternalModalOpen, setIsActiveExternalModalOpen] =
    useState(false);
  const [reMountComponent, setreMountComponent] = useState(false);
  const [reMountLocation, setreMountLocation] = useState(false);
  const [reMountStaff, setreMountStaff] = useState(false);
  const [reMountStatus, setreMountStatus] = useState(false);
  const [showDeletedLocations, setshowDeletedLocations] = useState(true);
  const [showDeletedStaff, setshowDeletedStaff] = useState(true);
  const [currentLocationId, setCurrentLocationId] = useState(null);
  const [currentStaffId, setCurrentStaffId] = useState(null);
  const [currentStatusId, setCurrentStatusId] = useState(null);
  const [isEditStatusOpen, setIsEditStatusOpen] = useState(false);
  const [isDeleteStatusOpen, setIsDeleteStatusOpen] = useState(false);
  const [isAddStatusOpen, setIsAddStatusOpen] = useState(false);
  const [isBillingDialogopen, setIsBillingDialogOpen] = useState(false);
  const [isDataBoundsModalOpen, setIsDataBoundsModalOpen] = useState(false);
  const [billingReportType, setBillingReportType] = useState(null);
  const [billingReportMonth, setBillingReportMonth] = useState(
    new Date().getMonth() + 1
  );
  const [billingReportYear, setBillingReportYear] = useState(
    new Date().getFullYear()
  );
  const navigate = useNavigate();
  const [statusList, setStatusList] = useState([]);

  const [initialLoading, setInitialLoading] = useState(false);
  const [isBillingReportDownloading, setIsBillingReportDownloading] =
    useState(false);
  const billingReportDownloadingRef = useRef(false);
  const [activeStatus, setActiveStatus] = useState("custom");
  const [activeTab, setActiveTab] = useState("locations");
  const identity = getUserIdentity(null);
  const isTocaUser = identity?.isToca ?? false;
  const canAccessLocation = identity?.isAdmin || identity?.isSuperAdmin || false;
  const isSuperAdmin = identity?.isSuperAdmin ?? false;
  const [activeStaffTab, setActiveStaffTab] = useState(isTocaUser ? "toca" : "non_toca");;

  const externalProviderQuery = useQuery(["external-providers"], () =>
    getExternalProviders(true)
  );

  const statusesQuery = useQuery(["admin-statuses"], () => getAllStatuses(), {
    onError: error => handleApiError(error),
    onSuccess: data => {
      setStatusList(data);
    }
  });

  // Helper to extract billing code status (mirrors BillingPage.js pattern)
  const getCodeStatus = (billings, code) => {
    const relevantBillings = billings?.filter(b => b.code === code && b.status !== "non_billable") || [];
    if (relevantBillings.length === 0) return "-";
    return relevantBillings.map(bill => `${bill.status}${bill.units > 1 ? ` x${bill.units}` : ""}`).join("; ");
  };

  // Function to handle billing report download — converts JSON to CSV
  const handleReportDownload = (data, includeSummary = false) => {
    const fullPatientList = data?.results?.patients || data?.patients || [];

    if (fullPatientList.length === 0) {
      toast.error("No data to export");
      return;
    }

    const csvRows = [];

    // If summary requested, prepend summary rows
    if (includeSummary && data?.status_summary) {
      const s = data.status_summary;
      csvRows.push("Summary");
      csvRows.push(`Total Billed,${s.total_billed ?? 0}`);
      csvRows.push(`Total Billable,${s.total_billable ?? 0}`);
      csvRows.push(`Total Paid,${s.total_paid ?? 0}`);
      csvRows.push(`Total Denied,${s.total_denied ?? 0}`);
      csvRows.push(`Total Appealed,${s.total_appealed ?? 0}`);
      csvRows.push(`Total Non-Billable,${s.total_non_billable ?? 0}`);
      csvRows.push(""); // blank line separator
    }

    let headers = [];
    if (billingReportType === "rpm") {
      headers = ["Patient Name", "DOB", "Provider", "Case Manager", "Facility", "ICD-10", "Consent Date", "DOS", "99453", "99445", "99454", "99470", "99457", "99458"];
    } else if (billingReportType === "ccm") {
      headers = ["Patient Name", "DOB", "Provider", "Case Manager", "Facility", "ICD-10", "Consent Date", "G0506", "99490", "99439", "99487", "99489"];
    }

    csvRows.push(headers.join(","));

    fullPatientList.forEach(p => {
      let row = [];
      if (billingReportType === "rpm") {
        const consentDate = p.RPM_setup_date || p.created_at;
        const targetCodes = ["99445", "99454"];
        const relevantBillings = p.rpm_billings?.filter(b => targetCodes.includes(b.code)) || [];
        let dosString = "--";

        if (relevantBillings.length > 0) {
          const entries = [];
          relevantBillings.forEach(bill => {
            if (bill.dates_of_service && bill.dates_of_service.length > 0) {
              bill.dates_of_service.forEach(ds => {
                const [y, m, d] = ds.split("-");
                const formatted = `${m}/${d}/${y}`;
                entries.push(`${formatted} (${bill.code})`);
              });
            }
          });
          if (entries.length > 0) dosString = entries.join("; ");
        } else {
          const oldDate = convertUTCToLocal(p.code_stats?.[0]?.[99454]?.created_at);
          if (oldDate) dosString = oldDate;
        }

        row = [
          `"${p.patient_name || ""}"`,
          formatUSADate(p.dob),
          `"${p.provider || "--"}"`,
          `"${p.case_manager || "--"}"`,
          `"${p.facility || "--"}"`,
          `"${(p.rpm_codes || []).join("; ")}"`,
          formatUSADate(consentDate),
          `"${dosString}"`,
          getCodeStatus(p.rpm_billings, "99453"),
          getCodeStatus(p.rpm_billings, "99445"),
          getCodeStatus(p.rpm_billings, "99454"),
          getCodeStatus(p.rpm_billings, "99470"),
          getCodeStatus(p.rpm_billings, "99457"),
          getCodeStatus(p.rpm_billings, "99458")
        ];
      } else if (billingReportType === "ccm") {
        const consentDate = p.created_at;
        row = [
          `"${p.patient_name || ""}"`,
          formatUSADate(p.dob),
          `"${p.provider || "--"}"`,
          `"${p.case_manager || "--"}"`,
          `"${p.facility || "--"}"`,
          `"${(p.icd_codes || []).join("; ")}"`,
          formatUSADate(consentDate),
          getCodeStatus(p.ccm_billings, "G0506"),
          getCodeStatus(p.ccm_billings, "99490"),
          getCodeStatus(p.ccm_billings, "99439"),
          getCodeStatus(p.ccm_billings, "99487"),
          getCodeStatus(p.ccm_billings, "99489")
        ];
      }
      csvRows.push(row.join(","));
    });

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8" });
    const sanitizedAccountName = sanitizeAccountName(tenantInfo?.name);
    const program = billingReportType.toUpperCase();
    const paddedMonth = String(billingReportMonth).padStart(2, "0");
    const filename = `${billingReportYear}-${paddedMonth}_${sanitizedAccountName}_billing_${program}.csv`;
    saveAs(blob, filename);

    toast.success("Report Downloaded Successfully");
  };

  // System-wide billing report query (without summary)
  const systemWideReport = useQuery(
    [
      "system-wide-report",
      billingReportYear,
      billingReportMonth,
      billingReportType
    ],
    () =>
      getSummary(
        `${billingReportYear}-${billingReportMonth}`,
        billingReportType,
        undefined,
        undefined,
        undefined,
        undefined,
        1,
        false
      ),
    {
      enabled: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: data => {
        handleReportDownload(data, false);
        billingReportDownloadingRef.current = false;
        setIsBillingReportDownloading(false);
      },
      onError: () => {
        toast.error("Could not download the report");
        billingReportDownloadingRef.current = false;
        setIsBillingReportDownloading(false);
      }
    }
  );

  // System-wide billing report query (with summary)
  const systemWideReportWithSummary = useQuery(
    [
      "system-wide-report-summary",
      billingReportYear,
      billingReportMonth,
      billingReportType
    ],
    () =>
      getSummary(
        `${billingReportYear}-${billingReportMonth}`,
        billingReportType,
        undefined,
        undefined,
        undefined,
        undefined,
        1,
        false
      ),
    {
      enabled: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: data => {
        handleReportDownload(data, true);
        billingReportDownloadingRef.current = false;
        setIsBillingReportDownloading(false);
      },
      onError: () => {
        toast.error("Could not download the report");
        billingReportDownloadingRef.current = false;
        setIsBillingReportDownloading(false);
      }
    }
  );

  const handleLocationClick = id => {
    navigate(`/admin/locations/${id}`);
  };

  const handleBillingReportDownload = withSummary => {
    if (!isTocaUser || billingReportDownloadingRef.current) return;
    billingReportDownloadingRef.current = true;
    setIsBillingReportDownloading(true);
    if (withSummary) {
      systemWideReportWithSummary.refetch();
    } else {
      systemWideReport.refetch();
    }
  };

  const handleBillingReport = billingType => {
    if (!isTocaUser) return;
    setBillingReportType(billingType);
    setIsBillingDialogOpen(true);
  };

  // ============ Parent Account related functions ==================
  useEffect(() => {
    const fetchAdminInfo = async () => {
      if (!isTocaUser) return;
      setInitialLoading(true);
      const token = localStorage.getItem("authToken");
      const tenantId = sessionStorage.getItem("acc_id");
      const url = `${BASE_URL}/tenants/${tenantId}/detail/`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        setTenantInfo(response.data);
        sessionStorage.setItem("acc_id", response.data.id);
        setInitialLoading(false);
      } catch (error) {
        handleApiError(error);
      }
    };

    fetchAdminInfo();
  }, [reMountComponent]);

  // Edit Account modal functions
  const openEditAccountModal = () => {
    setIsEditModalOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeEditAccountModal = () => {
    setIsEditModalOpen(false);
    document.body.style.overflow = "auto";
  };

  // ============ Locations related functions ==================
  useEffect(() => {
    const fetchLocationList = async () => {
      setLocationsLoading(true);
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const url = `${BASE_URL}/accounts/${account_id}/locations/?status=${showDeletedLocations ? "active" : "inactive"
        }`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        setLocationList(response.data.locations);
        setLocationsLoading(false);
      } catch (error) {
        handleApiError(error);
      }
    };

    fetchLocationList();
  }, [reMountLocation, showDeletedLocations]);

  // Add Location modal functions
  const openAddlocationModal = () => {
    setIsAddlocationOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeAddlocationModal = () => {
    setIsAddlocationOpen(false);
    document.body.style.overflow = "auto";
  };

  // Edit Location modal functions
  const openEditlocationModal = id => {
    setCurrentLocationId(id);
    setIsEditlocationOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeEditlocationModal = () => {
    setIsEditlocationOpen(false);
    document.body.style.overflow = "auto";
  };

  // Delete Location modal functions
  const openDeleteModal = id => {
    setCurrentLocationId(id);
    setIsDeleteModalOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    document.body.style.overflow = "auto";
  };

  // Activate Location modal functions
  const openActiveModal = id => {
    setCurrentLocationId(id);
    setIsActiveModalOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeActiveModal = () => {
    setIsActiveModalOpen(false);
    document.body.style.overflow = "auto";
  };

  // ============ Staff related functions ==================
  const staffStatus = showDeletedStaff ? "active" : "inactive";

  const staffQuery = useQuery(
    ["staff-list", staffStatus, activeStaffTab, reMountStaff],
    async () => {
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const url = `${BASE_URL}/accounts/${account_id}/staff-list/?status=${staffStatus}&user_type=${activeStaffTab}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return showDeletedStaff
        ? response.data.staff.filter(staff => staff.account_role !== null)
        : response.data.staff;
    },
    {
      enabled: activeTab === "staff",
      staleTime: 1000 * 60 * 2, // 2 minutes — switching toca ↔ non_toca won't refetch if data is fresh
      onError: error => handleApiError(error)
    }
  );

  const StructuredStaffData = staffQuery?.data?.map(row => ({
    ...row,
    fullName: `${row?.user?.first_name} ${row?.user?.last_name}`,
    email: row?.user?.email,
    assigned_patient_count: row?.functional_role === "Care Manager" || row?.functional_role === "Nurse" ? row?.assigned_patient_count : "--",
    max_patient_limit: row?.functional_role === "Care Manager" || row?.functional_role === "Nurse" ? row?.max_patient_limit : "--"
  }));

  // ============ Status related functions ==================
  // handled by React Query: statusesQuery above

  // Add Staff modal functions
  const openAddStaffModal = () => {
    setIsAddStaffOpen(true);
    document.body.style.overflow = "hidden";
  };

  const openAddExternalStaffModal = () => {
    setIsAddExternalStaffOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeAddStaffModal = () => {
    setIsAddStaffOpen(false);
    document.body.style.overflow = "auto";
  };

  const closeAddExternalStaffModal = () => {
    setIsAddExternalStaffOpen(false);
    document.body.style.overflow = "auto";
  };

  // Edit Staff modal functions
  const openEditStaffModal = id => {
    setCurrentStaffId(id);
    setIsEditStaffOpen(true);
    document.body.style.overflow = "hidden";
  };

  const openEditExternalStaffModal = id => {
    setCurrentStaffId(id);
    setIsEditExternalStaffOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeEditStaffModal = () => {
    setIsEditStaffOpen(false);
    document.body.style.overflow = "auto";
  };

  const closeEditExternalStaffModal = () => {
    setIsEditExternalStaffOpen(false);
    document.body.style.overflow = "auto";
  };

  // Active staff modal functions
  const openActiveStaffModal = id => {
    setCurrentStaffId(id);
    setIsActiveModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const openActiveExternalStaffModal = id => {
    setCurrentStaffId(id);
    setIsActiveExternalModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeActiveStaffModal = () => {
    setIsActiveModalOpen(false);
    document.body.style.overflow = "auto";
  };

  const closeActiveExternalStaffModal = () => {
    setIsActiveExternalModalOpen(false);
    document.body.style.overflow = "auto";
  };

  // Delete staff modal functions
  const openDeleteStaffModal = id => {
    setCurrentStaffId(id);
    setIsDeleteStaffModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const openDeleteExternalStaffModal = id => {
    setCurrentStaffId(id);
    setIsDeleteExternalStaffModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeDeleteStaffModal = () => {
    setIsDeleteStaffModalOpen(false);
    document.body.style.overflow = "auto";
  };

  const closeDeleteExternalStaffModal = () => {
    setIsDeleteExternalStaffModalOpen(false);
    document.body.style.overflow = "auto";
  };

  // ============ Status related functions ==================
  // Add Status modal functions
  const openAddStatusModal = () => {
    setIsAddStatusOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeAddStatusModal = () => {
    setIsAddStatusOpen(false);
    document.body.style.overflow = "auto";
  };

  // Edit Status modal functions
  const openEditStatusModal = id => {
    setCurrentStatusId(id);
    setIsEditStatusOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeEditStatusModal = () => {
    setIsEditStatusOpen(false);
    document.body.style.overflow = "auto";
  };

  // Delete Status modal functions
  const openDeleteStatusModal = id => {
    setCurrentStatusId(id);
    setIsDeleteStatusOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeDeleteStatusModal = () => {
    setIsDeleteStatusOpen(false);
    document.body.style.overflow = "auto";
  };

  // Data bounds modal functions
  const openDataBoundsModal = () => {
    setIsDataBoundsModalOpen(true);
    // Static implementation - no API fetch needed
    document.body.style.overflow = "hidden";
  };

  const closeDataBoundsModal = () => {
    setIsDataBoundsModalOpen(false);
    document.body.style.overflow = "auto";
  };

  const formatDate = dateString => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const user = JSON.parse(localStorage.getItem("user"));

  // filtered data to show in lists
  const filteredData =
    activeTab === "locations"
      ? locationList
        ? [...locationList]
          .reverse()
          .filter(row =>
            row.name.toLowerCase().includes(nameSearch.toLowerCase())
          )
        : []
      : activeTab === "staff"
        ? StructuredStaffData
          ?
          StructuredStaffData?.filter(row => {
            const fullName =
              `${row.user.first_name} ${row.user.last_name}`.toLowerCase();
            const matchesName = fullName.includes(nameSearch.toLowerCase());
            const matchesPosition = activeStaffTab === "non_toca"
              ? (row?.account_position?.title ?? "")
                .toLowerCase()
                .includes(positionSearch.toLowerCase())
              : true;
            return matchesName && matchesPosition;
          })
          : []
        : activeTab === "external"
          ? externalProviderQuery.data.filter(row => {
            const matchName = row.name
              .toLowerCase()
              .includes(nameSearch.toLocaleLowerCase());
            return matchName;
          })
          : statusList.filter(row => {
            const matchesName = row.name
              .toLowerCase()
              .includes(nameSearch.toLowerCase());
            return matchesName;
          });

  const locationTableColumns = [
    { key: "name", label: "Name", alignLeft: true },
    {
      key: "created_at",
      label: "Created At",
      render: row => displayDate(row.created_at)
    },
    { key: "patients_count", label: "Total Patients" },
    { key: "active_patients", label: "Active Patients" },
    { key: "inactive_patients", label: "Inactive Patients" },
    { key: "staff_count", label: "Staff Count" },
    {
      key: "actions",
      sorting: false,
      label: "Actions",
      render: row => (
        <div className={styles.action_btns}>
          {showDeletedLocations ? (
            <>
              <Button
                variant="ghost"
                onClick={e => {
                  e.stopPropagation();
                  openEditlocationModal(row.id);
                }}
              >
                <FontAwesomeIcon icon={faFilePen} />
              </Button>
              {locationId !== row.id && locationList.length > 1 && (
                <Button
                  variant="ghost"
                  onClick={e => {
                    e.stopPropagation();
                    openDeleteModal(row.id);
                  }}
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                </Button>
              )}
            </>
          ) : (
            <>
              <Button
                onClick={e => {
                  e.stopPropagation();
                  openActiveModal(row.id);
                }}
              >
                Activate
              </Button>
            </>
          )}
        </div>
      )
    }
  ];

  const tocaStaffTableColumns = [
    {
      key: "fullName",
      label: "Name",
      alignLeft: true,
    },
    {
      key: "email",
      label: "Email",
      alignLeft: true,
    },
    {
      key: "functional_role",
      label: "Role",
    },
    {
      key: "max_patient_limit",
      label: "Max Patient Limit",
    },
    {
      key: "assigned_patient_count",
      label: "Assigned Patients",
    },
    {
      key: "actions",
      sorting: false,
      label: "Actions",
      render: row => (
        <div className={styles.action_btns}>
          {row.id !== staffId && (
            <>
              {showDeletedStaff ? (
                <>
                  <Button
                    variant="ghost"
                    onClick={() => openEditStaffModal(row.id)}
                  >
                    <FontAwesomeIcon icon={faFilePen} />
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => openDeleteStaffModal(row.id)}
                  >
                    <FontAwesomeIcon icon={faTrashCan} />
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    onClick={e => {
                      e.stopPropagation();
                      openActiveStaffModal(row.id);
                    }}
                  >
                    Activate
                  </Button>
                </>
              )}
            </>
          )}
        </div>
      )
    }

  ];

  const nonTocaStaffTableColumns = [
    {
      key: "name",
      label: "Name",
      alignLeft: true,
      render: row => `${row.user.first_name} ${row.user.last_name}`
    },
    {
      key: "email",
      label: "Email",
      alignLeft: true,
      render: row => row.user.email
    },
    {
      key: "role",
      label: "Role",
      render: row => {
        const roles = [];
        if (row?.functional_role) {
          roles.push(row?.functional_role);
        }
        if (row?.external_role?.name === "TOCA Admin") {
          roles.push("TOCA Admin");
        }
        if (row?.external_role?.name === "TOCA Inventory Manager") {
          roles.push("TOCA Inventory Manager");
        }

        if (
          row?.account_roles?.some(_role => _role.name === "Super User") &&
          row?.external_role?.name !== "TOCA Admin"
        ) {
          roles.push("Super User");
        }
        if (row?.account_roles?.some(_role => _role.name === "Account Admin")) {
          roles.push("Account Admin");
        }

        return <p>{roles.join(" / ")}</p>;
      }
    },
    {
      key: "position",
      label: "Position",
      render: row => row.account_position?.title || "None"
    },
    {
      key: "actions",
      sorting: false,
      label: "Actions",
      render: row => (
        <div className={styles.action_btns}>
          {row.id !== staffId && (
            <>
              {showDeletedStaff ? (
                <>
                  <Button
                    variant="ghost"
                    onClick={() => openEditStaffModal(row.id)}
                  >
                    <FontAwesomeIcon icon={faFilePen} />
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => openDeleteStaffModal(row.id)}
                  >
                    <FontAwesomeIcon icon={faTrashCan} />
                  </Button>
                </>
              ) : (
                <Button
                  onClick={e => {
                    e.stopPropagation();
                    openActiveStaffModal(row.id);
                  }}
                >
                  Activate
                </Button>
              )}
            </>
          )}
        </div>
      )
    },
  ];

  const statusTableColumns = [
    {
      key: "name",
      label: "Name",
      alignLeft: true,
      render: row => <p>{row.name}</p>
    },
    {
      key: "description",
      label: "Description",
      alignLeft: true,
      sorting: false
    },
    {
      key: "actions",
      sorting: false,
      label: "Action",
      render: row => (
        <div className={styles.action_btns}>
          {!row.is_default ? (
            <>
              <Button
                variant="ghost"
                onClick={() => openEditStatusModal(row.id)}
              >
                <FontAwesomeIcon icon={faFilePen} />
              </Button>
              <Button
                variant="ghost"
                onClick={() => openDeleteStatusModal(row.id)}
              >
                <FontAwesomeIcon icon={faTrashCan} />
              </Button>
            </>
          ) : (
            <section
              className={styles.default_status}
              title="System-defined status. Cannot edit/delete."
            >
              <Badge>
                <FaLock size={14} />
              </Badge>
            </section>
          )}
        </div>
      )
    }
  ];

  const externalStaffTableColumns = [
    {
      key: "name",
      label: "Name",
      alignLeft: true,
      render: row => `${row.name}`
    },
    {
      key: "email",
      label: "Email",
      alignLeft: true,
      render: row => row.email
    },
    {
      key: "phone",
      label: "Phone",
      render: row => (row.phone_number ? row.phone_number : "None")
    },
    {
      key: "actions",
      sorting: false,
      label: "Actions",
      render: row => (
        <div className={styles.action_btns}>
          {showDeletedStaff ? (
            <>
              <Button
                variant="ghost"
                onClick={() => openEditExternalStaffModal(row.id)}
              >
                <FontAwesomeIcon icon={faFilePen} />
              </Button>
              <Button
                variant="ghost"
                onClick={() => openDeleteExternalStaffModal(row.id)}
              >
                <FontAwesomeIcon icon={faTrashCan} />
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={e => {
                  e.stopPropagation();
                  openActiveExternalStaffModal(row.id);
                }}
              >
                Activate
              </Button>
            </>
          )}
        </div>
      )
    }
  ];

  return (
    <div className={styles.admin_page}>
      <div className={styles.admin_page_container}>
        {initialLoading ? (
          <div className={styles.spinner_container}>
            <Spinner />
          </div>
        ) : (
          <>
            {/* ===== dashboard =====  */}
            {isTocaUser && (
              <div className={styles.dashboard_wrapper}>

                <div className={styles.heading}>
                  <div>
                    <p>{tenantInfo?.name}</p>
                  </div>
                  {isSuperAdmin && (
                    <div className={styles.actionSection}>
                      <Button onClick={() => navigate("/admin/instructional-videos")}>
                        <FaVideo color="white" />
                        Instructional Videos
                      </Button>
                      {roles.includes("TOCA Admin") && (
                        <Button onClick={() => navigate("/admin/add-organization")}>
                          <FaPlus color="white" />
                          Add Organization
                        </Button>
                      )}
                    </div>
                  )}
                </div>

                <div className={styles.dashboard_container}>
                  <div className={styles.dashboard}>
                    <div className={styles.dash_item}>
                      <div className={styles.dashboard_heading}>
                        <p>Created On</p>

                        <Tooltip
                          content={`Creation date of ${tenantInfo?.name}`}
                          position="top"
                        >
                          <span>?</span>
                        </Tooltip>
                      </div>
                      <div className={styles.value}>
                        <p>{displayDate(tenantInfo?.created_at)}</p>
                      </div>
                    </div>
                    <div className={styles.dash_item}>
                      <div className={styles.dashboard_heading}>
                        <p>Total Locations</p>
                        <Tooltip
                          content={`Total Location count of ${tenantInfo?.name}`}
                          position="top"
                        >
                          <span>?</span>
                        </Tooltip>
                      </div>
                      <div className={styles.value}>
                        <p>{tenantInfo?.locations_count}</p>
                      </div>
                    </div>
                    <div className={styles.dash_item}>
                      <div className={styles.dashboard_heading}>
                        <p>Total Patients</p>
                        <Tooltip
                          content={`Total Patient(s) onboarded in ${tenantInfo?.name}`}
                          position="top"
                        >
                          <span>?</span>
                        </Tooltip>
                      </div>
                      <div className={styles.value}>
                        <p>{tenantInfo?.patient_count}</p>
                      </div>
                    </div>

                    <div className={styles.dash_item}>
                      <div className={styles.dashboard_heading}>
                        <p>Active Patients</p>
                        <Tooltip
                          content={`Total Active Patient(s) in ${tenantInfo?.name}`}
                          position="top"
                        >
                          <span>?</span>
                        </Tooltip>
                      </div>
                      <div className={styles.value}>
                        <p>{tenantInfo?.patient_stats?.active}</p>
                      </div>
                    </div>

                    <div className={styles.dash_item}>
                      <div className={styles.dashboard_heading}>
                        <p>In-Active Patients</p>
                        <Tooltip
                          content={`Total In-Active Patient(s) in ${tenantInfo?.name}`}
                          position="top"
                        >
                          <span>?</span>
                        </Tooltip>
                      </div>
                      <div className={styles.value}>
                        <p>{tenantInfo?.patient_stats?.inactive}</p>
                      </div>
                    </div>
                  </div>

                  <div className={styles.actions_wrapper}>
                    <div className={styles.action} onClick={openEditAccountModal}>
                      <div className={styles.action_img}>
                        <img
                          src={
                            require(`../../assets/images/docs.png`).default ||
                            "/placeholder.svg"
                          }
                          alt=" "
                        />
                      </div>
                      <p className={styles.action_heading}>Edit Information</p>
                    </div>

                    {isEditModalOpen && (
                      <EditAccountInfoModal
                        isOpen={isEditModalOpen}
                        onClose={() => {
                          setIsEditModalOpen(false);
                          document.body.style.overflow = "auto";
                        }}
                      />
                    )}

                    <div
                      className={styles.action}
                      onClick={() => handleBillingReport("rpm")}
                    >
                      <div className={styles.action_img}>
                        <img
                          src={
                            require(`../../assets/images/download.png`).default ||
                            "/placeholder.svg"
                          }
                          alt=" "
                        />
                      </div>
                      <p className={styles.action_heading}>
                        Organization Wide RPM Billing Report
                      </p>
                    </div>
                    <Dialog
                      open={isBillingDialogopen}
                      setOpen={() => setIsBillingDialogOpen(false)}
                    >
                      <DialogContent>
                        <DialogHeader>
                          <DialogTitle>Organization Wide {billingReportType?.toUpperCase()} Billing Report</DialogTitle>
                        </DialogHeader>
                        <DialogBody>
                          <div className={styles.form_row}>
                            <div className={styles.form_group}>
                              <label>Month</label>
                              <Select
                                onChange={value => setBillingReportMonth(value)}
                                value={billingReportMonth}
                              >
                                <SelectTrigger>
                                  <SelectValue placeholder="Select a month">
                                    <p>
                                      {
                                        months.find(
                                          m => m.value == billingReportMonth
                                        )?.label
                                      }
                                    </p>
                                  </SelectValue>
                                </SelectTrigger>
                                <SelectContent>
                                  {(parseInt(billingReportYear) ===
                                    new Date().getFullYear()
                                    ? months.slice(0, new Date().getMonth() + 1)
                                    : months
                                  ).map(month => (
                                    <SelectItem key={month.value} value={month.value}>
                                      {month.label}
                                    </SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            </div>
                          </div>
                          <div className={styles.form_row}>
                            <div className={styles.form_group}>
                              <label>Year</label>
                              <Select
                                onChange={value => setBillingReportYear(value)}
                                value={billingReportYear}
                              >
                                <SelectTrigger>
                                  <SelectValue placeholder="Select year">
                                    {billingReportYear ?? "Select year"}
                                  </SelectValue>
                                </SelectTrigger>
                                <SelectContent>
                                  {generateYears(2024)
                                    .reverse()
                                    .map(year => (
                                      <SelectItem key={year} value={year}>
                                        {year}
                                      </SelectItem>
                                    ))}
                                </SelectContent>
                              </Select>
                            </div>
                          </div>
                        </DialogBody>
                        <DialogFooter>
                          <Button
                            variant="ghost"
                            onClick={() => setIsBillingDialogOpen(false)}
                          >
                            Cancel
                          </Button>
                          <Button
                            disabled={isBillingReportDownloading}
                            loading={systemWideReportWithSummary.isFetching}
                            onClick={() => handleBillingReportDownload(true)}
                          >
                            Download with summary
                          </Button>
                          <Button
                            disabled={isBillingReportDownloading}
                            loading={systemWideReport.isFetching}
                            onClick={() => handleBillingReportDownload(false)}
                          >
                            Download
                          </Button>
                        </DialogFooter>
                      </DialogContent>
                    </Dialog>

                    <div
                      className={styles.action}
                      onClick={() => handleBillingReport("ccm")}
                    >
                      <div className={styles.action_img}>
                        <img
                          src={
                            require(`../../assets/images/download.png`).default ||
                            "/placeholder.svg"
                          }
                          alt=" "
                        />
                      </div>
                      <p className={styles.action_heading}>
                        Organization Wide CCM Billing Report
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}

            {/* ===== Data ===== */}
            <div className={styles.patient_wrapper}>
              <div className={styles.top}>
                <p className={styles.heading}>
                  {activeTab === "locations"
                    ? "Locations"
                    : activeTab === "staff"
                      ? "Staff"
                      : activeTab == "external"
                        ? "External Providers"
                        : "Statuses"}
                </p>
                <div className={styles.top_left}>
                  {activeTab === "locations" ? (
                    <>
                      <Button onClick={openDataBoundsModal} variant="normal">

                        Configure Data Bounds
                      </Button>
                      {canAccessLocation && isTocaUser ? (
                        <Button onClick={openAddlocationModal}>
                          <FaPlus color="white" />
                          Add Location
                        </Button>
                      ) : null}

                    </>
                  )
                    : activeTab === "staff" ? (
                      <Button
                        onClick={openAddStaffModal}
                      >
                        <FaPlus color="white" />
                        Add Staff
                      </Button>
                    )
                      : activeTab === "external" ? (
                        <Button
                          onClick={openAddExternalStaffModal}
                        >
                          <FaPlus color="white" />
                          Add External Provider
                        </Button>
                      ) : (
                        activeStatus === "custom" && (
                          <Button onClick={openAddStatusModal}>
                            <FaPlus color="white" />
                            Add Status
                          </Button>
                        )
                      )}

                  {isAddlocationOpen && (
                    <AddLocationModal
                      isOpen={isAddlocationOpen}
                      onClose={closeAddlocationModal}
                      comp_renderer={setreMountLocation}
                      current_render={reMountLocation}
                    />
                  )}

                  {isAddStaffOpen && (
                    <AddStaffModal
                      isOpen={isAddStaffOpen}
                      onClose={closeAddStaffModal}
                      comp_renderer={setreMountStaff}
                      current_render={reMountStaff}
                    />
                  )}

                  {isAddExternalStaffOpen && (
                    <AddExternalStaff
                      isOpen={isAddExternalStaffOpen}
                      onClose={closeAddExternalStaffModal}
                      comp_renderer={setreMountStaff}
                      current_render={reMountStaff}
                    />
                  )}

                  {isAddStatusOpen && (
                    <AddStatusModal
                      isOpen={isAddStatusOpen}
                      onClose={closeAddStatusModal}
                      comp_renderer={setreMountStatus}
                      current_render={reMountStatus}
                    />
                  )}
                </div>
              </div>
              <ToggleTabs defaultValue="locations" onChange={setActiveTab}>
                <ToggleTabList>
                  <ToggleTabTrigger value="locations">
                    Locations
                  </ToggleTabTrigger>
                  <ToggleTabTrigger value="staff">Staff</ToggleTabTrigger>
                  <ToggleTabTrigger value="external">
                    External Providers
                  </ToggleTabTrigger>
                  <ToggleTabTrigger value="status">Statuses</ToggleTabTrigger>
                </ToggleTabList>

                <ToggleTabPanels>
                  <TogglePanel value="locations">
                    <div className={styles.table_container}>
                      <div className={styles.show_chat}>
                        <Button
                          variant={showDeletedLocations ? "ghost" : "primary"}
                          onClick={() =>
                            setshowDeletedLocations(!showDeletedLocations)
                          }
                        >
                          {`Show ${showDeletedLocations ? "deleted" : "Active"
                            } Locations`}
                        </Button>
                      </div>

                      <div
                        className={`${styles.searchbar_container} ${styles.location_search}`}
                      >
                        <div className={styles.input_wrapper}>
                          <input
                            type="text"
                            placeholder="Search by Name"
                            value={nameSearch}
                            onChange={e => setNameSearch(e.target.value)}
                          />
                          <img alt=" " src={search || "/placeholder.svg"} />
                        </div>
                      </div>

                      <div className={styles.all_patients}>
                        <Table
                          columns={locationTableColumns}
                          data={filteredData}
                          isRowClickable={true}
                          onRowClick={
                            showDeletedLocations
                              ? row => handleLocationClick(row.id)
                              : null
                          }
                          loading={LocationsLoading}
                        />

                        {isDeleteModalOpen && (
                          <DeleteLocation
                            isOpen={isDeleteModalOpen}
                            onClose={closeDeleteModal}
                            location_info={
                              locationList
                                ? [...locationList].find(
                                  location =>
                                    location.id === currentLocationId
                                )
                                : {}
                            }
                            comp_renderer={setreMountLocation}
                            current_render={reMountLocation}
                          />
                        )}

                        {isActiveModalOpen && (
                          <ActiveLocation
                            isOpen={isActiveModalOpen}
                            onClose={closeActiveModal}
                            location_info={
                              locationList
                                ? [...locationList].find(
                                  location =>
                                    location.id === currentLocationId
                                )
                                : {}
                            }
                            comp_renderer={setreMountLocation}
                            current_render={reMountLocation}
                          />
                        )}

                        {isEditlocationOpen && (
                          <EditLocationModal
                            isOpen={isEditlocationOpen}
                            onClose={closeEditlocationModal}
                            location_info={
                              locationList
                                ? [...locationList].find(
                                  location =>
                                    location.id === currentLocationId
                                )
                                : {}
                            }
                            comp_renderer={setreMountLocation}
                            current_render={reMountLocation}
                          />
                        )}
                      </div>
                    </div>
                  </TogglePanel>

                  <TogglePanel value="staff">
                    <div className={styles.table_container}>
                      <div className={styles.status_switch}>
                        <Button
                          variant={showDeletedStaff ? "ghost" : "primary"}
                          onClick={() => setshowDeletedStaff(!showDeletedStaff)}
                        >
                          {`Show ${showDeletedStaff ? "deleted" : "active"
                            } staff`}
                        </Button>
                        {isTocaUser && (
                          <Button
                            variant={activeStaffTab !== "toca" ? "ghost" : undefined}
                            onClick={() => setActiveStaffTab("toca")}
                          >
                            Toca
                          </Button>
                        )}
                        {isTocaUser && (<Button
                          variant={activeStaffTab !== "non_toca" ? "ghost" : undefined}
                          onClick={() => setActiveStaffTab("non_toca")}
                        >
                          Non Toca
                        </Button>)}
                      </div>

                      <div
                        className={`${styles.searchbar_container} ${styles.location_search}`}
                      >
                        <div className={styles.input_wrapper}>
                          <input
                            type="text"
                            placeholder="Search by Name"
                            value={nameSearch}
                            onChange={e => setNameSearch(e.target.value)}
                          />
                          <img alt=" " src={search || "/placeholder.svg"} />
                        </div>

                        {activeStaffTab === "non_toca" && (
                          <div className={styles.input_wrapper}>
                            <input
                              type="text"
                              placeholder="Search by Position"
                              value={positionSearch}
                              onChange={e => setPositionSearch(e.target.value)}
                            />
                            <img alt=" " src={search || "/placeholder.svg"} />
                          </div>
                        )}
                      </div>

                      <div className={styles.all_patients}>
                        <Table
                          columns={activeStaffTab === "toca" ? tocaStaffTableColumns : nonTocaStaffTableColumns}
                          data={filteredData}
                          loading={staffQuery.isLoading}
                        />

                        {/* ✅ FIX 1: staffList → staffQuery.data */}
                        {/* ✅ Guard: render only when staffInfo is available */}
                        {isEditStaffOpen && (() => {
                          const staffInfo = staffQuery.data?.find(staff => staff.id === currentStaffId);
                          if (!staffInfo) return null;
                          return (
                            <EditStaffModal
                              isOpen={isEditStaffOpen}
                              onClose={closeEditStaffModal}
                              staff_info={staffInfo}
                              comp_renderer={setreMountStaff}
                              current_render={reMountStaff}
                            />
                          );
                        })()}

                        {isActiveModalOpen && (() => {
                          const staffInfo = staffQuery.data?.find(staff => staff.id === currentStaffId);
                          if (!staffInfo) return null;
                          return (
                            <ActiveStaffModal
                              isOpen={isActiveModalOpen}
                              onClose={closeActiveStaffModal}
                              staff_info={staffInfo}
                              comp_renderer={setreMountStaff}
                              current_render={reMountStaff}
                            />
                          );
                        })()}

                        {isDeleteStaffModalOpen && (() => {
                          const staffInfo = staffQuery.data?.find(staff => staff.id === currentStaffId);
                          if (!staffInfo) return null;
                          return (
                            <DeleteStaff
                              isOpen={isDeleteStaffModalOpen}
                              onClose={closeDeleteStaffModal}
                              staff_info={staffInfo}
                              comp_renderer={setreMountStaff}
                              current_render={reMountStaff}
                            />
                          );
                        })()}
                      </div>
                    </div>
                  </TogglePanel>

                  <TogglePanel value="external">
                    <div className={styles.table_container}>
                      <div
                        className={`${styles.searchbar_container} ${styles.location_search}`}
                      >
                        <div className={styles.input_wrapper}>
                          <input
                            type="text"
                            placeholder="Search by Name"
                            value={nameSearch}
                            onChange={e => setNameSearch(e.target.value)}
                          />
                          <img alt=" " src={search || "/placeholder.svg"} />
                        </div>
                      </div>

                      <div className={styles.all_patients}>
                        <Table
                          columns={externalStaffTableColumns}
                          data={filteredData}
                          loading={externalProviderQuery.isLoading}
                        />

                        {isEditExternalStaffOpen && (
                          <EditExternalStaff
                            isOpen={isEditExternalStaffOpen}
                            onClose={closeEditExternalStaffModal}
                            staff_info={
                              externalProviderQuery.data
                                ? [...externalProviderQuery.data].find(
                                  staff => staff.id === currentStaffId
                                )
                                : {}
                            }
                            comp_renderer={setreMountStaff}
                            current_render={reMountStaff}
                          />
                        )}

                        {isActiveExternalModalOpen && (
                          <ActiveExternalStaff
                            isOpen={isActiveExternalModalOpen}
                            onClose={closeActiveExternalStaffModal}
                            staff_info={
                              externalProviderQuery.data
                                ? [...externalProviderQuery.data].find(
                                  staff => staff.id === currentStaffId
                                )
                                : {}
                            }
                            comp_renderer={setreMountStaff}
                            current_render={reMountStaff}
                          />
                        )}

                        {isDeleteExternalStaffModalOpen && (
                          <DeleteExternalStaff
                            isOpen={isDeleteExternalStaffModalOpen}
                            onClose={closeDeleteExternalStaffModal}
                            staff_info={
                              externalProviderQuery.data
                                ? [...externalProviderQuery.data].find(
                                  staff => staff.id === currentStaffId
                                )
                                : {}
                            }
                            comp_renderer={setreMountStaff}
                            current_render={reMountStaff}
                          />
                        )}
                      </div>
                    </div>
                  </TogglePanel>

                  <TogglePanel value="status">
                    <section className={styles.status_container}>
                      <section className={styles.status_switch}>
                        <Button
                          variant={activeStatus !== "custom" ? "ghost" : "primary"}
                          onClick={() => setActiveStatus("custom")}
                        >
                          Custom
                        </Button>
                        <Button
                          variant={activeStatus !== "default" ? "ghost" : "primary"}
                          onClick={() => setActiveStatus("default")}
                        >
                          Default
                        </Button>
                      </section>
                      {activeStatus === "custom" ? (
                        <div className={styles.table_container}>
                          <div className={styles.searchbar_container}>
                            <div className={styles.input_wrapper}>
                              <input
                                type="text"
                                placeholder="Search by Name"
                                value={nameSearch}
                                onChange={e => setNameSearch(e.target.value)}
                              />
                              <img alt=" " src={search || "/placeholder.svg"} />
                            </div>
                          </div>

                          <div className={styles.all_patients}>
                            <Table
                              columns={statusTableColumns}
                              data={filteredData.filter(
                                _status => !_status.is_default
                              )}
                              loading={initialLoading}
                            />

                            {isEditStatusOpen && (
                              <EditStatusModal
                                isOpen={isEditStatusOpen}
                                onClose={closeEditStatusModal}
                                status_info={statusList.find(
                                  status => status.id === currentStatusId
                                )}
                                comp_renderer={setreMountStatus}
                                current_render={reMountStatus}
                              />
                            )}

                            {isDeleteStatusOpen && (
                              <DeleteStatus
                                isOpen={isDeleteStatusOpen}
                                onClose={closeDeleteStatusModal}
                                status_info={statusList.find(
                                  status => status.id === currentStatusId
                                )}
                                comp_renderer={setreMountStatus}
                                current_render={reMountStatus}
                              />
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className={styles.table_container}>
                          <div className={styles.searchbar_container}>
                            <div className={styles.input_wrapper}>
                              <input
                                type="text"
                                placeholder="Search by Name"
                                value={nameSearch}
                                onChange={e => setNameSearch(e.target.value)}
                              />
                              <img alt=" " src={search || "/placeholder.svg"} />
                            </div>
                          </div>

                          <div className={styles.all_patients}>
                            <Table
                              columns={statusTableColumns}
                              data={filteredData.filter(
                                _status => _status.is_default
                              )}
                              loading={initialLoading}
                              rowColor={row =>
                                row.is_default && "var(--light-blue)"
                              }
                            />

                            {isEditStatusOpen && (
                              <EditStatusModal
                                isOpen={isEditStatusOpen}
                                onClose={closeEditStatusModal}
                                status_info={statusList.find(
                                  status => status.id === currentStatusId
                                )}
                                comp_renderer={setreMountStatus}
                                current_render={reMountStatus}
                              />
                            )}

                            {isDeleteStatusOpen && (
                              <DeleteStatus
                                isOpen={isDeleteStatusOpen}
                                onClose={closeDeleteStatusModal}
                                status_info={statusList.find(
                                  status => status.id === currentStatusId
                                )}
                                comp_renderer={setreMountStatus}
                                current_render={reMountStatus}
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </section>
                  </TogglePanel>
                </ToggleTabPanels>
              </ToggleTabs>
            </div>
          </>
        )}

        {/* Data Bounds Modal */}
        {isDataBoundsModalOpen && (
          <OrgDataBoundsModal
            isOpen={isDataBoundsModalOpen}
            onClose={closeDataBoundsModal}
            onSaved={() => {
              // Refresh logic if needed after saving
            }}
          />
        )}
      </div>
    </div >
  );
};

export default CaseManagerAdmin;